module.exports = __webpack_public_path__ + "media/styles/images/svg/ex-white-b6b34f1dee5cd490adb28c43cb12fc64.svg";